import React from 'react';

interface Props {
  isGray?: boolean;
  width?: string;
}

const SearchIconSVG: React.FC<Props> = ({ isGray = false, width }) => (
  <svg
    width={width ?? '15'}
    height={width ?? '15'}
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='8.16667'
      cy='8.16667'
      r='6.66667'
      stroke={isGray ? '#A6A6A6' : '#FFFFFF'}
      strokeWidth='2.5'
      strokeLinecap='round'
    />
    <path
      d='M12.75 13.1308L16.9167 17.2975'
      stroke={isGray ? '#A6A6A6' : '#FFFFFF'}
      strokeWidth='2.5'
      strokeLinecap='round'
    />
  </svg>
);

export default SearchIconSVG;
